import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { isLinkFieldValue } from './internal/is-link-field-value';

/**
 * Determines if the given field is a LinkField.
 *
 * @param field - The field to check.
 * @returns True if the field is a LinkField, otherwise false.
 */
export const isLinkField = (field: Field): field is LinkField => {
  return typeof field === 'object' && field !== null && isLinkFieldValue(field.value);
};
